define(['app'], function (app) {
    app.filter('absNumber', [function () {
        return function (val) {
            return Math.abs(val);
        }
    }]);
});
